import { DocumentType } from '../types/supabase';

export interface DocumentTypeMapping {
  documentType: DocumentType;
  documentSubtype: string;
}

const documentKeyToTypeMap: Record<string, DocumentType> = {
  // Identity documents
  KBIS: 'IDENTITY',
  STATUTS: 'LEGAL_DOCUMENT',
  JOAFE: 'IDENTITY',
  PV_AG_CA: 'LEGAL_DOCUMENT',

  // Financial documents
  RIB: 'FINANCIAL_STATEMENT',
  BILAN: 'FINANCIAL_STATEMENT',
  BUDGET_PREV: 'FINANCIAL_STATEMENT',
  PLAN_FIN: 'FINANCIAL_STATEMENT',

  // Legal & fiscal documents
  URSSAF: 'CERTIFICATE',
  FISCAL: 'CERTIFICATE',
  ASSURANCE_RC: 'CERTIFICATE',
  RBE: 'LEGAL_DOCUMENT',
  ID_DIRIGEANT: 'IDENTITY',

  // Project documents
  NOTE_PROJET: 'OTHER',
  BUSINESS_PLAN: 'BUSINESS_PLAN',
  CALENDRIER: 'OTHER',
  ETUDE_FAIS: 'OTHER',

  // HR documents
  EFFECTIF: 'OTHER',
  REG_INTERIEUR: 'LEGAL_DOCUMENT',
  ACCORDS: 'LEGAL_DOCUMENT',

  // Specific documents
  DOMICILIATION: 'LEGAL_DOCUMENT',
  DEVIS_FACTURES: 'OTHER',
  CERTIF: 'CERTIFICATE',
  VISUELS: 'OTHER',
};

export function mapDocumentKeyToTypes(documentKey: string): DocumentTypeMapping {
  const documentType = documentKeyToTypeMap[documentKey] || 'OTHER';

  return {
    documentType,
    documentSubtype: documentKey,
  };
}

export function getDocumentCategoryLabel(documentType: DocumentType): string {
  const labels: Record<DocumentType, string> = {
    BUSINESS_PLAN: 'Plan d\'affaires',
    FINANCIAL_STATEMENT: 'Document financier',
    LEGAL_DOCUMENT: 'Document légal',
    IDENTITY: 'Identification',
    CERTIFICATE: 'Attestation',
    OTHER: 'Autre',
    KBIS: 'KBIS',
    RIB: 'RIB',
    DESCRIPTION: 'Description',
  };

  return labels[documentType] || 'Autre';
}
